import { destroyCookie } from "nookies";
import { COOKIES } from "@/constants/cookies";
import { DEFAULT_ROUTES, isPublicRoute } from "@/constants/routes";

export const handleUnauthorized = () => {
  if (isPublicRoute(window.location.pathname)) {
    return;
  }

  // Avoid infinite redirect loop if already on signin page
  if (window.location.pathname === DEFAULT_ROUTES.SIGNIN) {
    return;
  }

  // Clear authentication cookies
  destroyCookie(undefined, COOKIES.BACKOFFICE_AUTH, {
    path: "/",
    domain: "woba.com.br",
  });
  destroyCookie(undefined, COOKIES.U_TOKEN, {
    path: "/",
    domain: "woba.com.br",
  });

  // Redirect to signin
  window.location.href = DEFAULT_ROUTES.SIGNIN;
};
